const PLAN_CUSTOM_UNITS = 'custom';
const PRICING_MODEL_TYPE_FREE = 'free';
const PRICING_MODEL_TYPE_FREEMIUM = 'freemium';
const PRICING_MODEL_TYPE_PAID = 'paid';
const PRICING_MODEL_TYPE_FREETOINSTSALL = 'free_to_install';
const PRICING_MODELS_FREE = [PRICING_MODEL_TYPE_FREE, PRICING_MODEL_TYPE_FREEMIUM, PRICING_MODEL_TYPE_FREETOINSTSALL];

export const isPaidListing = (pricing: schema.oaf.Pricing): boolean => {
    return pricing?.price_model_type === PRICING_MODEL_TYPE_PAID;
};

export const isFreeListing = (pricing: schema.oaf.Pricing): boolean => {
    return pricing?.price_model_type === PRICING_MODEL_TYPE_FREE;
};
export const isFreemiumListing = (pricing: schema.oaf.Pricing): boolean => {
    return pricing?.price_model_type === PRICING_MODEL_TYPE_FREEMIUM;
};
export const isFreeToInstallListing = (pricing: schema.oaf.Pricing): boolean => {
    return pricing?.price_model_type === PRICING_MODEL_TYPE_FREETOINSTSALL;
};
/*
 * TODO (W-11390239) We are temporarily going to normalize the 3 types of "free" listings and display them all just as "free".
 * In the future, we will be supporting 3 different types of free listings and this code will then need to be changed
 */
export const isFreeListingPreTransparency = (pricing: schema.oaf.Pricing): boolean => {
    return PRICING_MODELS_FREE.includes(pricing?.price_model_type);
};

export const getPlanUnits = (plan: schema.oaf.SubscriptionPricePlan): string => {
    return (plan?.units === PLAN_CUSTOM_UNITS ? plan.custom_unit : plan?.units) ?? '';
};

export const isLowestStartingPrice = (plan: schema.oaf.SubscriptionPricePlan): boolean => {
    return Boolean(plan?.lowest_starting_price);
};

export const isPaidWithCheckout = (pricing: schema.oaf.Pricing): boolean => {
    // @ts-expect-error * Automated Type Error Fix
    const pricingModel: schema.oaf.PricingModel = pricing?.model;
    if (isPaidListing(pricing)) {
        return (pricingModel as schema.oaf.Paid).payment_type === 'salesforce_provided';
    }
    return false;
};

export const hasDiscountNonProfits = (pricing: schema.oaf.Pricing): boolean => {
    // @ts-expect-error * Automated Type Error Fix
    const pricingModel: schema.oaf.PricingModel = pricing?.model;
    if (isPaidListing(pricing)) {
        // @ts-expect-error * Automated Type Error Fix
        return (pricingModel as schema.oaf.Paid).discounts_offered;
    } else if (isFreeToInstallListing(pricing)) {
        // @ts-expect-error * Automated Type Error Fix
        return (pricingModel as schema.oaf.FreeToInstall).discounts_offered;
    } else if (isFreemiumListing(pricing)) {
        // @ts-expect-error * Automated Type Error Fix
        return (pricingModel as schema.oaf.Freemium).discounts_offered;
    }
    return false;
};
//adding some comment to check verified commits
export const getPlanPrice = (currency: string, price: number): string => {
    if (currency && price) {
        // TODO - I18N: This formatting does not take into account the current language
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
            unitDisplay: 'short',
            currencyDisplay: 'narrowSymbol',
            signDisplay: 'never',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }).format(price);
    }
    // if we don't get necessary data to format the price we just return empty string
    return '';
};
